import {icon} from 'leaflet';
import imageShadow from './shadow.png';
import imagePurple from './icon-purple.png';
import imagePurple2x from './icon-purple-2x.png';
import imagePink from './icon-pink.png';
import imagePink2x from './icon-pink-2x.png';
import imageRed from './icon-red.png';
import imageRed2x from './icon-red-2x.png';
import imageYellow from './icon-yellow.png';
import imageYellow2x from './icon-yellow-2x.png';

interface Base {
  iconSize: [number, number],
  iconAnchor: [number, number],
  popupAnchor: [number, number],
  tooltipAnchor: [number, number],
  shadowSize: [number, number],
};

const base: Base = {
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  tooltipAnchor: [16, -28],
  shadowSize: [41, 41],
};

export const iconPink = icon({
  iconUrl: imagePink,
  iconRetinaUrl: imagePink2x,
  shadowUrl: imageShadow,
  ...base,
});

export const iconPurple = icon({
  iconUrl: imagePurple,
  iconRetinaUrl: imagePurple2x,
  shadowUrl: imageShadow,
  ...base,
});

export const iconRed = icon({
  iconUrl: imageRed,
  iconRetinaUrl: imageRed2x,
  shadowUrl: imageShadow,
  ...base,
});

export const iconYellow = icon({
  iconUrl: imageYellow,
  iconRetinaUrl: imageYellow2x,
  shadowUrl: imageShadow,
  ...base,
});
